import axios from 'axios';
import { env } from 'src/config/env';

function fetchViews(params) {
  const instance = axios.create({
    baseURL: env.INTEL_URL,
  });

  return instance.get('/api/insights/views', {
    params,
  });
}

export default fetchViews;
